<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" :menu="tabs" :type-id="typeId" :sub-type-id="subTypeId"
                @getList="getList"></type-menu>
            <div class="content">
                <div class="c-header">
                    <div class="header-group-left">
                        <el-button type="primary" size="mini" @click="open">创建新闻</el-button>
                        <el-button type="danger" size="mini" :disabled="!this.multipleSelection" @click="delAll">删除</el-button>
                        <!-- <el-dropdown>
                            <el-button type="default" plain size="mini"> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>批量删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="请输入内容" v-model="query.keyword" class="input-with-select" size="mini">
                                <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>


                <div class="c-main">
                    <div class="overflow-container">
                        <el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column prop="title" label="标题" width="200" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="封面" width="120">
                                <template slot-scope="scope">
                                    <el-image :src="scope.row.cover" :preview-src-list="[scope.row.cover]"> </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="updatedAt" label="更新时间" width="">
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="handleCommand({ type: 'edit', data: scope.row })" type="text"
                                        size="small">编辑</el-button>
                                    <el-button @click="handleCommand({ type: 'del', data: scope.row._id })" type="text"
                                        size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <div class="card">
                            <div class="card-item" v-for="item in list" :key="item._id">
                                <div class="card-item__img">
                                    <el-image :src="item.cover" :preview-src-list="[item.cover]"> </el-image>
                                </div>
                                <div class="card-detail">
                                    <div class="card-detail__name">{{ item.title }}</div>
                                    <div class="card-detail__time">更新: {{ item.updatedAt }}</div>
                                </div>
                                <div class="card-control">
                                    <el-checkbox class="checkbox" v-model="item.checked"></el-checkbox>
                                    <el-dropdown @command="handleCommand">
                                        <el-button type="text" size="mini" class="el-icon-more more"></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                :command="{ type: 'edit', data: item }">编辑</el-dropdown-item>
                                            <el-dropdown-item
                                                :command="{ type: 'del', data: item._id }">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="page">
                        <el-pagination class="" @current-change="handleCurrentChange" :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
                            layout="total, prev, pager, next, jumper" :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-if="dialogVisible" :fullscreen="true" :title="dialogTitle" :visible.sync="dialogVisible">

            <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px">
                <div class="article-form">
                    <div class="article-form-left">
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="form.title" size="small"></el-input>
                        </el-form-item>

                        <el-form-item label="新闻" prop="content">
                            <FaRichText style="width: 100%;height: 500px" v-model="form.content" />
                        </el-form-item>
                    </div>
                    <div class="article-form-right">
                        <div class="article-form-right-item">
                            <el-form-item label="新闻封面" prop="cover">
                                <FaImageUpload v-model="form.cover" :maxCount="1" />
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getSubCategories, saveMaterials, delMaterials } from "@/api/material";

import TypeMenu from "@/pages/mall/components/TypeMenu.vue";

export default {
    props: {
        typeId: String,
    },
    components: {
        TypeMenu,
    },
    data() {
        return {
            multipleSelection: "",
            tabs: [],
            list: [],
            subTypeId: "",
            once: false,
            keyword: "",
            categoryId: "",
            dialogVisible: false,
            dialogTitle: "",
            form: {
                _id: "",
                title: "",
                content: "",
                cover: "",
            },
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                cover: [
                    { required: true, message: '请输入封面', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ]
            }
        };
    },
    watch: {
        list: {
            handler(val) {
                if (val.length === 0) {
                    this.checked = false;
                    return
                }
                const tag = val.every((item) => item.checked === true);

            },
            deep: true,
        },
    },
    created() {
        this.initList();
    },
    methods: {
        async initList() {
            this.query = {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: '',
            }
            await this.getList();
        },

        async getList(id) {
            if (id) {
                this.subTypeId = id;
                this.query = {
                    page: 1,
                    total: 0,
                    pageSize: 10,
                    keyword: '',
                }
            }
            const { status, data, message } = await getSubCategories({
                categoryId: this.typeId,
                page: this.query.page,
                pageSize: this.query.pageSize,
                filter: this.query.keyword,
            });
            if (status == 10000) {
                this.tabs = data;
                if (!this.once) {
                    this.subTypeId = this.tabs[0]?._id;
                    this.once = true;
                }
                const subList = data.filter((item) => item._id === this.subTypeId)[0];
                this.query.total = subList.totalPages;
                this.list = subList.materials.map((item) => {
                    return {
                        checked: false,
                        ...item,
                    };
                });
            } else {
                this.$message.error(message);
            }
        },

        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },

        open(data) {
            this.dialogTitle = data?._id ? "编辑新闻" : "添加新闻";
            this.form = {
                _id: data._id,
                title: data.title,
                content: data.content,
                cover: data.cover,
            };
            this.dialogVisible = true;
        },

        save(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let method = "POST";
                    if (this.form._id) {
                        method = "PUT";
                    }
                    const { status, message } = await saveMaterials(method, {
                        id: this.form._id,
                        title: this.form.title,
                        category: this.typeId,
                        subCategory: this.subTypeId,
                        content: this.filterHtml(this.form.content),
                        cover: this.form.cover,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message,
                        });
                        this.getList();
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(message);
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        del(ids) {
            this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const { status, message } = await delMaterials({
                        id: ids,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getList();
                        this.multipleSelection = "";
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    console.info("已取消删除!");
                });
        },

        delAll() {
            const ids = this.multipleSelection;
            this.del(ids);
        },

        handleCommand({ type: command, data }) {
            switch (command) {
                case "edit":
                    this.open(data);
                    break;
                case "del":
                    this.del(data);
                    break;
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val.map((item) => item._id).join(",");
        },

        // 添加 HTML 过滤函数
        filterHtml(html) {
            // 移除潜在的危险标签和属性
            return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                .replace(/on\w+="[^"]*"/g, '')
                .replace(/javascript:/gi, '')
        }
    },
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 100%;

    .containter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 8px;

        .content {
            flex: 1 1 auto;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0 0px 16px;
        }

        .c-header {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2n) {
                margin-top: 8px;
            }
        }

        .header-group-left {
            .el-button {
                min-width: 80px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }

        .c-main {
            position: relative;
            padding: 6px 0 42px;
            height: 100%;
            flex: 1 1 auto;
            min-height: auto;

            .overflow-container {
                height: 100%;
                overflow-y: auto;
           
                // 滚动条整体样式
                &::-webkit-scrollbar {
                    display: block;
                    width: 6px;
                    height: 6px;
                }

                // 滚动条轨道
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                // 滚动条滑块
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .page {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                bottom: 0px;
                width: 100%;
            }
        }

        .card {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
        }

        .card-item {
            display: flex;
            flex-direction: column;
            width: 160px;
            min-height: 200px;
            position: relative;

            &:not(:first-child) {
                margin-bottom: 24px;
                margin-left: 16px;
            }

            &:hover {
                .card-item__img {
                    border: 1px solid #2061e6;
                }
            }

            .card-item__img {
                width: 160px;
                height: 160px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f6f7f8;
                box-sizing: border-box;
                border: 1px solid transparent;

                img {
                    display: block;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }
            }

            .card-control {
                display: flex;
                align-items: center;
                position: absolute;
                width: 100%;
                top: 0;
                padding: 4px 8px;

                .checkbox {
                    margin-right: auto;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
                }

                .el-button+.el-dropdown {
                    margin-left: 6px;
                }

                .eye,
                .more {
                    padding: 0px;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    color: #8c8c8cad;
                    font-weight: bold;
                    background: #fff;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);

                    &:hover {
                        background: #ededed;
                    }
                }

                .more {
                    font-weight: normal;
                }
            }
        }

        .card-detail {
            padding-top: 8px;

            .card-detail__name {
                font-size: 400;
                color: #333;
            }

            .card-detail__info {
                display: flex;
                justify-content: space-between;
                gap: 10px;

                span {
                    min-width: 72px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            div {
                margin-bottom: 8px;
                font-size: 12px;
                color: #999;
            }
        }
    }
}

.article-form {
    width: 100%;
    display: flex;
    gap: 24px;
}

.article-form-left {
    width: 800px;
}

.article-form-right {
    width: 300px;
}
</style>
<style>
.filepond--root :not(text) {
    font-size: 16px;
}
</style>